module.exports = __webpack_public_path__ + "static/img/cloud.dec5eb4c.png";